const EASE_MS = 250;
// The run still easing on each element, so a new one can settle it first.
const running = new WeakMap();

const reducedMotion = () => typeof window.matchMedia === 'function'
  && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/**
 * Eases `el` from the box it had (`from`, measured before the change) to the
 * one it has now. Neither the dialog's width (a max-width) nor its height
 * (auto) animates on its own, so both are pinned for the transition and
 * released when it ends.
 */
export function animateBox(el, from) {
  if (!el || !from) return;
  // A run still under way is settled first, so the new size is measured with
  // nothing pinned and the old run's timer can't clear this one's styles.
  if (running.has(el)) running.get(el)();
  if (reducedMotion()) return;
  const to = { width: el.offsetWidth, height: el.offsetHeight };
  if (to.width === from.width && to.height === from.height) return;
  const { style } = el;
  // max-width outranks width, so it is lifted for the run or a shrinking box
  // would land on its end width on the first frame.
  style.transition = 'none';
  style.maxWidth = 'none';
  style.width = `${from.width}px`;
  style.height = `${from.height}px`;
  style.overflow = 'hidden';
  void el.offsetWidth; // commit the starting box
  style.transition = `width ${EASE_MS}ms ease-out, height ${EASE_MS}ms ease-out`;
  style.width = `${to.width}px`;
  style.height = `${to.height}px`;

  let settled = false;
  const done = (e) => {
    if (settled || (e && e.target !== el)) return;
    settled = true;
    running.delete(el);
    el.removeEventListener('transitionend', done);
    ['transition', 'maxWidth', 'width', 'height', 'overflow'].forEach((k) => { style[k] = ''; });
  };
  running.set(el, done);
  el.addEventListener('transitionend', done);
  setTimeout(done, EASE_MS + 150); // in case the event never arrives
}
